/**
 * AddSubscriptionAccessoriesCtrl controller
 */

import { ACCESSORY_TYPES_FOR_FILTERS } from '../../app/core/constants'

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

/**
 * AddSubscriptionAccessoriesCtrl controller
 *
 * @class AddSubscriptionAccessoriesCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddSubscriptionAccessoriesCtrl
 */
/* @ngInject */
export function AddSubscriptionAccessoriesCtrl ($uibModalInstance, accessories, subscription) {
  const vm = this
  vm.accessoryTypes = ACCESSORY_TYPES_FOR_FILTERS
  vm.isFormDisabled = true

  /**
   * Subscription
   *
   * @memberof mwApp/packages.controller:AddSubscriptionAccessoriesCtrl
   * @type {models.Subscription}
   */
  vm.subscription = subscription

  /**
   *
   * @type {{available: {arr}, assigned: {arr: ([string]|*[])}}}
   */
  vm.accessories = {
    available: { arr: accessories },
    assigned: { arr: angular.copy(vm.subscription?.assignedAccessories || []) }
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index, event) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()

    list.arr = list.arr
      .slice(0, index)
      .concat(items)
      .concat(list.arr.slice(index))
    items.forEach(item => { item.selected = !item.selected })
    vm.isFormDisabled = false
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    link.selected = true
    return list.filter(link => link.selected)
  }

  /**
   * Delete Accessory
   *
   * @memberof mwApp/packages.controller:AddSubscriptionAccessoriesCtrl
   */
  vm.deleteAccessory = function (accessory) {
    event.preventDefault()
    accessory.selected = false
    vm.accessories.assigned.arr = vm.accessories.assigned.arr.filter(s => s.id !== accessory.id)
    vm.accessories.available.arr.push(accessory)
    vm.isFormDisabled = false
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => { item.selected = false })
    list.dragging = false
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.arr = list.arr.filter(item => !item.selected)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/packages.controller:AddSubscriptionAccessoriesCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  /**
   * Assign accessories, and close modal window afterwards
   *
   * @memberof mwApp/packages.controller:AddSubscriptionAccessoriesCtrl
   */
  vm.submit = function () {
    $uibModalInstance.close(vm.accessories.assigned.arr)
  }
}
